import type * as Immutable from 'immutable';

import useAppSelector from 'stores/useAppSelector';
import { selectUndeclaredParameters } from 'views/logic/slices/searchMetadataSelectors';

const useUndeclaredParameters = (): Immutable.Set<string> => useAppSelector(selectUndeclaredParameters);

export default useUndeclaredParameters;
